module.exports = __webpack_public_path__ + "fonts/great-vibes-regular.ttf";